import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-18114dde"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center",
    "font-size": "12px",
    "color": "gray"
  }
}, " 权益类产品信息仅供参考，具体以托管数据为准 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active = $event),
      sticky: "",
      animated: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_tab, {
        title: "类固收"
      }, {
        default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
          ref: "ListViewCpt",
          request: $options.rqtPostTradeFixList,
          requestParameter: $data.searchForm,
          isPaging: false
        }, {
          default: _withCtx(({
            item
          }) => [_hoisted_1, _createVNode(_component_van_cell, {
            title: item.productName
          }, {
            label: _withCtx(() => [_createElementVNode("div", null, "金额: " + _toDisplayString(item.actualSubscriptionAmount) + "元", 1), _createElementVNode("div", null, "预期年化收益: " + _toDisplayString(item.expectedInterestRate) + "%", 1), _createElementVNode("div", null, "成立日: " + _toDisplayString(item.foundDate), 1), _createElementVNode("div", null, "到期日: " + _toDisplayString(item.expireDate), 1), _createElementVNode("div", null, "付息方式: " + _toDisplayString(item.distributionMethod), 1)]),
            _: 2
          }, 1032, ["title"])]),
          _: 1
        }, 8, ["request", "requestParameter"])]),
        _: 1
      }), _createVNode(_component_van_tab, {
        title: "权益类"
      }, {
        default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
          ref: "ListViewCpt2",
          request: $options.rqtPostTradeEquityList,
          requestParameter: $data.equitySearchForm,
          isPaging: false
        }, {
          default: _withCtx(({
            item
          }) => [_hoisted_2, _createVNode(_component_van_cell, {
            title: item.productName
          }, {
            label: _withCtx(() => [_createElementVNode("div", null, "存续份额: " + _toDisplayString(item.leftShare), 1), _createElementVNode("div", null, "单位净值: " + _toDisplayString(item.netValue) + " (" + _toDisplayString(item.publicDate) + ")", 1), _createElementVNode("div", null, "累计净值: " + _toDisplayString(item.accumulateNetValue) + " (" + _toDisplayString(item.publicDate) + ")", 1), _createElementVNode("div", null, "预估存续资产: " + _toDisplayString(item.leftAmount), 1)]),
            _: 2
          }, 1032, ["title"])]),
          _: 1
        }, 8, ["request", "requestParameter"]), _hoisted_3]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}